import { createRouter, createWebHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
//import NavBar from '../components/NavBar.vue'
import BasePageVue from '@/components/BasePage.vue'
import DashboardPage from '@/components/DashboardPage.vue'
import DashboardPageUsb from '@/components/DashboardPageUsb.vue'
import CampaignsPage from '@/components/CampaignsPage.vue'
import CampaignsPageUsb from '@/components/CampaignsPageUsb.vue'
import CampaignResultsPage from '@/components/CampaignResultsPage.vue'
import CampaignUsbResultsPage from '@/components/CampaignUsbResultsPage.vue'
import GroupsPage from '@/components/GroupsPage.vue'
import TemplatesPage from '@/components/TemplatePage.vue'
import SendingProfilesPage from '@/components/SendingProfilesPage.vue'
//import LandingPagesPage from '@/components/LandingPagesPage.vue'
import SettingsPage from '@/components/SettingsPage.vue'
import UserManagmentPage from '@/components/UserManagmentPage.vue'
import CustomersPage from '@/components/CustomersPage.vue'


// const routes = [
//   //{ path: '/', name: 'home',  component: HomeView},
//   {path: '/',  name: 'home',  component: BasePageVue},
//   {path: '/login',  name: 'login',  component: BasePageVue},
//   {path: '/campaigns', name: 'campaigns', component: CampaignsPage },
//   {path: '/campaigns/:id', name: 'campaign', component: CampaignResultsPage },
//   {path: '/dashboard', name: 'dashboard', component: DashboardPage },
//   {path: '/groups', name: 'groups', component: GroupsPage },
//   {path: '/templates', name: 'templates', component: TemplatesPage },
//   {path: '/sending_profiles', name: 'sending_profiles', component: SendingProfilesPage },
//   {path: '/landing_pages', name: 'landing_pages', component: LandingPagesPage },
//   {path: '/settings', name: 'settings', component: SettingsPage },
//   {path: '/users', name: 'users', component: UserManagmentPage }
  
//   //{ path: '/about', name: 'about', // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//   //  component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue') 
//  // }
// ]




const routes = [

  //{ path: '/', name: 'home',  component: HomeView},

  { path: '/',

    name: 'home',

    component: BasePageVue,

    meta: {title: 'Home'}

    ,

    beforeEnter: (to, from ,next) => {

      let  isAuthenticated = window.sessionStorage.getItem('user');
      const isAuth = null!=isAuthenticated; // is Authenticated
      if (isAuth) {
          next("/dashboard");
      }
      else {
          next();
      }
    }

   

  },

 

  { path: '/login',

   name: 'login',

   component: BasePageVue,

   meta: {title: 'Login'},

   beforeEnter: (to, from ,next) => {

      let user =  window.sessionStorage.getItem('user');
      let isAuth = null!=user; // is Authenticated
      if (isAuth) {
        next("/dashboard");
       }
        else {

            next();

        }

    }

  },


  { path: '/campaigns',

    name: 'campaigns',

    component: CampaignsPage,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Campaignes'},
    //meta: {title: 'Campaignes' },


    beforeEnter: (to, from ,next) => {

    const isAuthenticated = window.sessionStorage.getItem('user');
    let  isAuth = null!=isAuthenticated;
    const user =JSON.parse(isAuthenticated);
    const  role = user.role;
    if (isAuth) {
      if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)||(role=="Reader" && user.phishing) ) {
      //console.log(role);
      next();
      }
      else {
      alert(" NOT AUTHORIZED ")
      sessionStorage.clear();
      next("/login");
    }
    }
    else {
      alert(" NOT AUTHORIZED ")
      sessionStorage.clear();
      next("/login");
    }

  
    }

  },

  { path: '/campaignsUsb',

    name: 'campaignsUsb',

    component: CampaignsPageUsb,

    //meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'usb', title: 'Campaignes Usb Ducky' },
    // meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'usb', title: 'Campagnes Usb'}
    // old meta ->  
    //meta: { title: 'Campagnes Usb'},
    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag2', title: 'Campagnes Usb'},


    beforeEnter: (to, from ,next) => {

      const isAuthenticated = window.sessionStorage.getItem('user');
      let  isAuth = null!=isAuthenticated;
      const user =JSON.parse(isAuthenticated);
      const  role = user.role;
      if (isAuth) {
        if ((role=="Admin" && user.usb )||(role=="User" && user.usb)||(role=="Reader" && user.usb)) {
        console.log(role);
        next();
        }
        else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }
      }
      else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }

    }

  },

  { path: '/campaigns/:id',

    name: 'campaign',

    component: CampaignResultsPage ,

    //meta: {title: 'Campaigne'},
    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Campagnes'},
    beforeEnter: (to, from ,next) => {

      const isAuthenticated = window.sessionStorage.getItem('user');
      let  isAuth = null!=isAuthenticated;
      const user =JSON.parse(isAuthenticated);
      const  role = user.role;
      if (isAuth) {
        if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)||(role=="Reader" && user.phishing) ) {
          next();
        }
        else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }
      }
      else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }



    }

  }
,
  { path: '/campaignsUsb/:id',

  name: 'campaignUsb',

  component: CampaignUsbResultsPage ,

  // richiede:  Auth, Roles, flag, title 
  //meta: {title: 'Campagnes Usb'},
  meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag2', title: 'Campagne Usb'},

  beforeEnter: (to, from ,next) => {

    
      const isAuthenticated = window.sessionStorage.getItem('user');
      let  isAuth = null!=isAuthenticated;
      const user =JSON.parse(isAuthenticated);
      const  role = user.role;
      if (isAuth) {
        if ((role=="Admin" && user.usb )||(role=="User" && user.usb)||(role=="Reader" && user.usb)) {
        console.log(role);
        next();
        }
        else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }
      }
      else {
        alert(" NOT AUTHORIZED ")
        sessionStorage.clear();
        next("/login");
      }
    
   
  }

}


    ,

  { path: '/dashboard',

    name: 'dashboard',

    component: DashboardPage ,

   // meta: {title: 'Dashboard'}
    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Dashboard '},
  

    beforeEnter: (to, from ,next) => {

        const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)||(role=="Reader" && user.phishing) ) {
            next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }


    }

  },

  { path: '/dashboardUsb',

    name: 'dashboardUsb',

    component: DashboardPageUsb ,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag2', title: 'Dashboard Usb'},

    //meta: {title: 'Dashboard Usb'}

  

    beforeEnter: (to, from ,next) => {


        const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.usb )||(role=="User" && user.usb)||(role=="Reader" && user.usb)) {
          console.log(role);
          next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }


    }

  }
  ,

  { path: '/groups',

    name: 'groups',

    component: GroupsPage ,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Groups'},

    beforeEnter: (to, from ,next) => {

      const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing) ) {
            next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }


    }
  },
  { path: '/templates',

    name: 'templates',

    component: TemplatesPage ,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Templates'},

    beforeEnter: (to, from ,next) => {

      const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)) {
            next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }

      
    }
  },
  { path: '/sending_profiles',

    name: 'sending_profiles',

    component: SendingProfilesPage ,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Sending Profiles'},

    beforeEnter: (to, from ,next) => {

      const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)) {
            next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }


     
    }
  },
  /*{ path: '/landing_pages',

    name: 'landing_pages',

    component: LandingPagesPage ,

    meta: {title: 'Landing Pages'}

    ,

    beforeEnter: (to, from ,next) => {

      let  isAuthenticated = window.sessionStorage.getItem('user');

      var isAuth = null!=isAuthenticated;

        if (isAuth) {

            next();

        }

        else {

            next("/login");

        }

    }
  },*/
  { path: '/settings',

    name: 'settings',

    component: SettingsPage ,

    meta: {requiresAuth:true, allowedRoles: ['Admin', 'User', 'Reader'], requiredFlag:'flag1', title: 'Settings '},

    beforeEnter: (to, from ,next) => {


      const isAuthenticated = window.sessionStorage.getItem('user');
        let  isAuth = null!=isAuthenticated;
        const user =JSON.parse(isAuthenticated);
        const  role = user.role;
        if (isAuth) {
          if ((role=="Admin" && user.phishing )||(role=="User" && user.phishing)) {
            next();
          }
          else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }
        }
        else {
          alert(" NOT AUTHORIZED ")
          sessionStorage.clear();
          next("/login");
        }


    }
  },
  { path: '/users',

    name: 'users',

    component: UserManagmentPage ,

    meta: {title: 'Users'}

    ,

    beforeEnter: (to, from ,next) => {

      let  isAuthenticated = window.sessionStorage.getItem('user');
      let userRole = JSON.parse(window.sessionStorage.getItem('user')).role;

      var isAuth = null!=isAuthenticated;

        if (isAuth) {

          if(userRole == "Admin" ){
            next();
          } else {
              next('/dashboard')
          }

        }

        else {
          
            next("/login");

        }

    }
  },{ path: '/customers',

  name: 'customers',

  component: CustomersPage,

  meta: {title: 'Customers' },

  beforeEnter: (to, from ,next) => {

    let  isAuthenticated = window.sessionStorage.getItem('user');
    let userRole = JSON.parse(window.sessionStorage.getItem('user')).role;

    var isAuth = null!=isAuthenticated;

      if (isAuth) {

        if(userRole == "Admin"){
          next();
        } else {
            next('/dashboard')
        }

      }

      else {

          next("/login");

      }

  }

}


]

 



 

 

const router = createRouter({

  history: createWebHistory(),

  mode: 'history',

  base: process.env.BASE_URL,

  linkExactActiveClass: 'active',

  linkActiveClass: 'active',

  routes

})


 

export default router


//function logoff() {
    
    //window.location.href = '/login';
    //next("/login");
//}